import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
//import { DataTablesModule } from "angular-datatables"
import { AppComponent } from './app.component';
import { DevExtremeModule, DxTemplateModule, DxLoadIndicatorModule } from "devextreme-angular"; 
import { DataService } from './shared/dataService';
import { HttpClientModule } from '@angular/common/http';
import {  CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DxButtonModule, DxDataGridModule } from 'devextreme-angular';
//ruters
 

import { DeviceInfoComponent } from "./device-info/device-info.component";
//Routers
import { RouterModule } from '@angular/router'

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AttLogComponent } from './att-log/att-log.component';
import { HomeComponent } from './home/home.component';
import { FormsModule } from '@angular/forms';
import { AccountComponent } from './account/account.component'; 
import { HomeRecordComponent } from './home/home.recod.componente';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { RecoverypasswordComponent } from './recoverypassword/recoverypassword.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { ProfileUserComponent } from './profile-user/profile-user.component';
//import { AngularMultiSelectModule } from 'angular4-multiselect-dropdown/angular4-multiselect-dropdown';


let routes = [
    { path: '', component: HomeComponent }, 
    { path: 'deviceInfo', component: DeviceInfoComponent },
    { path: 'attLog', component: AttLogComponent },
    { path: 'account', component: AccountComponent },
    { path: 'userInfo', component: UserInfoComponent },
    {path:"recoverypass", component: RecoverypasswordComponent},
    {path:"confirmEmail", component: ConfirmEmailComponent},
    {path:"profileUser", component: ProfileUserComponent},
]
console.log("app.modules.ts");
@NgModule({
  declarations: [
      AppComponent, 
      HomeComponent,
      DeviceInfoComponent,
      AttLogComponent,
      AccountComponent, 
      HomeRecordComponent, HeaderComponent, FooterComponent, UserInfoComponent, RecoverypasswordComponent, ConfirmEmailComponent, ProfileUserComponent
  ],
  imports: [
      BrowserModule,
      DxDataGridModule,
      HttpClientModule, 
      DxButtonModule,
      //DxDataGridModule,
      DevExtremeModule, 
      FormsModule,
      DxTemplateModule,
      DxLoadIndicatorModule, 
      RouterModule.forRoot(routes,
          {
              useHash: true,
              enableTracing: false//for debuggin of the Routes
          }),
  ],
    providers:
        [
            DataService
        ],
    bootstrap: [AppComponent],
    
})
export class AppModule { }
//platformBrowserDynamic().bootstrapModule(AppModule);